import { CareMap_RuleStatus, FindingType_Enumerated, } from '@app/advisor-shared';
import { valueID_No, valueID_Yes } from '@app/hcs-shared';
/**
 * Disease in/out. YES stays in. NO is out. Otherwise a CareMap RULE_OUT
 * outcome is out. A ruled-out disease stays out of the cockpit lists.
 */
export const diagnosisIsOut = (finding, ruleStatus) => {
    if (finding?.type === FindingType_Enumerated) {
        if (finding.valueIds.includes(valueID_Yes))
            return false;
        if (finding.valueIds.includes(valueID_No))
            return true;
    }
    return ruleStatus === CareMap_RuleStatus.RULE_OUT;
};
//# sourceMappingURL=diagnosis-is-out.js.map